var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgWifiIcon = function SvgWifiIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5734",
    "data-name": "Grupo 5734",
    transform: "translate(-517 -525)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1975",
    "data-name": "Ret\\xE2ngulo 1975",
    width: 50,
    height: 50,
    transform: "translate(517 525)",
    fill: "#fff",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_654",
    "data-name": "Grupo 654",
    transform: "translate(522.944 535.543)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2350",
    "data-name": "Caminho 2350",
    d: "M19.058,3.782a22.9,22.9,0,0,0-15.6,6.06C1.406,11.749-1.449,9.087.857,7a27.148,27.148,0,0,1,36.4,0c2.3,2.083-.555,4.745-2.6,2.838A22.911,22.911,0,0,0,19.058,3.782Z",
    transform: "translate(0)",
    fill: "#4b4b4b",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2351",
    "data-name": "Caminho 2351",
    d: "M14.885,4.943A15.781,15.781,0,0,0,4.4,8.866c-2.074,1.979-5-.566-2.782-2.686A19.843,19.843,0,0,1,14.885,1.161,19.827,19.827,0,0,1,28.15,6.18c2.22,2.12-.7,4.665-2.776,2.686A15.806,15.806,0,0,0,14.885,4.943Z",
    transform: "translate(4.172 6.261)",
    fill: "#4b4b4b",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2352",
    "data-name": "Caminho 2352",
    d: "M9.872,6.184A7.169,7.169,0,0,0,5.054,8.042,1.906,1.906,0,1,1,2.5,5.258a10.943,10.943,0,0,1,14.745,0,1.906,1.906,0,1,1-2.558,2.783A7.154,7.154,0,0,0,9.872,6.184Z",
    transform: "translate(9.185 12.884)",
    fill: "#4b4b4b",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2353",
    "data-name": "Caminho 2353",
    d: "M5.4,3.658A2.832,2.832,0,1,1,2.558,6.49,2.831,2.831,0,0,1,5.4,3.658Z",
    transform: "translate(13.661 19.591)",
    fill: "#4b4b4b",
    stroke: "#fff",
    strokeWidth: 1,
    fillRule: "evenodd"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWifiIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/wifi-icon.7a46b6b2.svg";
export { ForwardRef as ReactComponent };